export const designerI18n = {
  en: {
    elementsMenu: {
      insertImage: 'Insert image',
      insertText: 'Insert text',
      insertRectangle: 'Insert rectangle',
    },
    elementTools: {
      delete: 'Delete',
      bringToFront: 'Bring to front',
      sendToBack: 'Send to back',
      backgroundColor: 'Background color',
      bringForward: 'Bring forward',
      sendBackward: 'Send backward',
    },
    elements: {
      text: {
        placeholder: 'Type here',
      },
    },
  },
  es: {
    elementsMenu: {
      insertImage: 'Insertar imagen',
      insertText: 'Insertar texto',
      insertRectangle: 'Insertar rectángulo',
    },
    elementTools: {
      delete: 'Eliminar',
      bringToFront: 'Traer al frente',
      sendToBack: 'Enviar al fondo',
      backgroundColor: 'Color de fondo',
      bringForward: 'Traer adelante',
      sendBackward: 'Enviar atrás',
    },
    elements: {
      text: {
        placeholder: 'Escriba aquí',
      }
    },
  }
}